import slideToggle from '../../utils/slideToggle.js';

const collectionPageAccordion = () => {
  const accordions = document.querySelectorAll('.product-accordion__header, .collection-accordion__header, .collection-qa__header');

  accordions.forEach(accordion => {
    accordion.addEventListener('click', function () {
      this.classList.toggle('active');
      const panel = this.nextElementSibling;
      slideToggle(panel, 300);
    });
  });

  $('.company-proof').slick({
    dots: false,
    infinite: false,
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.prev-arrow--cp'),
    nextArrow: $('.next-arrow--cp'),
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

};

export default collectionPageAccordion;